import {
    BarPlot,
    ChartsGrid, ChartsTooltip,
    ChartsXAxis,
    ChartsYAxis,
    LinePlot,
    MarkPlot,
    ResponsiveChartContainer
} from "@mui/x-charts";
import {Skeleton} from "@mui/material";
import ValueNotReceivedMessage from "../ValueNotReceivedMessage/ValueNotReceivedMessage";

interface SeriesData {
    data: number[];
    label: string;
    type: 'bar' | 'line';
    color: string;
}

interface XAxisData {
    data: string[];
    id: string;
    label: string;
}
export interface ComboChartProps {
    data?: SeriesData[];
    xAxis?: XAxisData;
    isLoading?: boolean;
}
function ComboChart({data, xAxis, isLoading}: ComboChartProps) {
    if(!isLoading && ( data == undefined || xAxis == undefined)) {
        return( 
            <div style={{margin: '0 auto'}}>
                <ValueNotReceivedMessage />
            </div>
        );
    }
    
    if(isLoading) {
        return(
            <Skeleton variant={"rectangular"} height={'90%'} width={'90%'} sx={{margin: '0 auto'}} />
        )
    }
    
    return(
        <ResponsiveChartContainer
            series={data!}
            xAxis={[{data: xAxis!.data, scaleType: 'band', id: xAxis!.id}]}
        >
            <BarPlot />
            <LinePlot />
            <MarkPlot />
            <ChartsXAxis label={xAxis!.label} position={"bottom"} axisId={xAxis!.id} />
            <ChartsYAxis />
            <ChartsGrid horizontal />
            <ChartsTooltip />
        </ResponsiveChartContainer>
    )
}


export default ComboChart;